import React from 'react'
import LineDivider from './LineDivider'
import { ImageCarousel, VideoCarousel } from './carousel'
import Spacer from './spacer'

export const ConstructionUpdates = ({ videoUpdates, content, title, teamTitle, members }) => {
	return (
		<section id='construction'>
			<div className='pl80 pr80 m-p0' id='construction-wrapper'>
				<LineDivider containerClassName='p0 m-p0' />

				<p className='h2 max-1400'>{teamTitle}</p>
				<ImageCarousel carouselItems={members} />
				<Spacer />
				<div className='max-1400 ma'>
					<p className='h2' id='construction-title'>
						{title}
					</p>
					<p className='op-50 max-550 m-mb0 m-mt0'>{content}</p>
					<Spacer />
				</div>
				<VideoCarousel carouselItems={videoUpdates} />

				<LineDivider containerClassName='p0 mt20 m-p0' />
			</div>
		</section>
	)
}
